// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_vT0","cls2":"Comments-cls2_rUn Comments-cls1_vT0"};